var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinkingEmoji(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D787D6C2-BBAC-416F-BC02-D215A39E0400") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-&-Wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 60,
    fontWeight: "normal",
    "line-spacing": 35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-204",
    transform: "translate(-150.000000, -172.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uD83E\\uDD14"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 148.949998,
    y: 224.9999
  }, "\uD83E\uDD14"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkingEmoji);
export default __webpack_public_path__ + "static/media/thinking-emoji.39afd077efb4b0571b85ccb8eb2dcd54.svg";
export { ForwardRef as ReactComponent };